import React, { useEffect, useState } from "react";
import { Tooltip, type TooltipProps } from "@mui/material";

/**
 * A tooltip for a trigger that owns a menu, popover, or peek (#11426 nooks
 * N8, CD ruling — a global rule, not a per-trigger patch): the tooltip
 * drops for as long as the owned surface is open, and re-arms only after
 * the pointer leaves and re-enters the trigger — otherwise it flashes back
 * the instant the surface closes under a stationary cursor. The tooltip is
 * never the sole carrier of the trigger's name; the trigger keeps its
 * visible label or aria-label.
 */
const MenuTriggerTooltip: React.FC<
  Omit<TooltipProps, "open"> & { surfaceOpen: boolean }
> = ({ surfaceOpen, children, ...rest }) => {
  const [open, setOpen] = useState(false);
  // Opening the surface disarms the tooltip outright; a stationary cursor
  // gets no re-open until it leaves and re-enters (onOpen fires again).
  useEffect(() => {
    if (surfaceOpen) setOpen(false);
  }, [surfaceOpen]);
  return (
    <Tooltip
      {...rest}
      open={open && !surfaceOpen}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      {children}
    </Tooltip>
  );
};

export default MenuTriggerTooltip;
